import { Component, Input } from "@angular/core"
import { FormBuilder, FormGroup } from "@angular/forms";

import { CreditCard } from "@models/credit-card";

@Component({
  selector: 'credit-card-form',
  templateUrl: './credit-card-form.pug',
})
export class CreditCardFormComponent {
  @Input() creditCard: CreditCard
  @Input() hasFormBeenSubmitted: boolean
  @Input() mainForm: FormGroup
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/public/credit-card-form.ts